import type { LabelComponentType } from "../../../../common-deprecated/components/label/Label";
import { getLabelComponent } from "../../../../common-deprecated/components/label/Label";
import type { UseLabelType, UseOptionalLabelType } from "../../../../common-deprecated/hooks/useLabel";
import { getUseLabel, getUseOptionalLabel } from "../../../../common-deprecated/hooks/useLabel";
import type { EquipmentV2StateType } from "../redux/store";

// ----------------------------------------------------------------------
// Accessibility labels
// ----------------------------------------------------------------------
export const accessibilityLabels = {
    ariaNextTabs: "Next tabs",
    ariaPreviousTabs: "Previous tabs",
    ariaNextImage: "Next image",
    ariaPreviousImage: "Previous image",
};

export const equipmentV2Labels = {
    ...accessibilityLabels,
    // Standard equipment
    standardEquipmentTitle: "Standard Equipment",
    standardEquipmentDescription: "",

    // Optional equipment
    optionalEquipmentTitle: "Optional Equipment",
    optionalEquipmentDescription: "",

    // Common
    equipmentCustomize: "Customize",
    equipmentMoreInformation: "More information",
    equipmentViewMore: "View more",
    equipmentViewLess: "View less",

    // equipmentListInteriorPacks: "Interior Packs", // unused
    // equipmentListExteriorPacks: "Exterior Packs", // unused
    // equipmentListSafetyPacks: "Safety Packs", // unused
    equipmentListPacks: "Packs",
};

export type EquipmentV2LabelType = keyof typeof equipmentV2Labels;
type EquipmentLabelParamType = Partial<Record<"", string | number>>;

export const useEquipmentLabel = getUseLabel(
    (state: EquipmentV2StateType) => state.equipmentV2Settings.labels,
    (state: EquipmentV2StateType) => !!state.commonSettings.query.showDictionaryKeys,
) as UseLabelType<EquipmentV2LabelType, EquipmentLabelParamType>;
export const useEquipmentOptionalLabel = getUseOptionalLabel(
    (state: EquipmentV2StateType) => state.equipmentV2Settings.labels,
    (state: EquipmentV2StateType) => !!state.commonSettings.query.showDictionaryKeys,
) as UseOptionalLabelType<EquipmentV2LabelType, EquipmentLabelParamType>;
export const EquipmentV2Label = getLabelComponent(useEquipmentLabel) as LabelComponentType<
    EquipmentV2LabelType,
    EquipmentLabelParamType
>;
